import React, {useCallback, useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {
  Paper,
} from '@mui/material';

import {ESignDocumentDetails, ESignViewer, ESignSearchPanel} from '../../components';
import Card from '../../../../components/Card/CardBody';
import CardBody from '../../../../components/Card/CardBody';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import Grid from '@mui/material/Grid';
import LoadingSpinner from "../../../../components/Spinner/loading.spinner";
import {ESIGNING_STATUS} from "../../../../constants/ESIGNING_STATUS";
import {DOCUMENT_VIEWER_MODES} from "../../../../constants/DOCUMENT_VIEWER_MODES";
import FilterListIcon from "@mui/icons-material/FilterList";
import useStyles from './styles';
import TabList from "../../../../components/Tab/TabList";
import moment from "moment";
import {AccordionCard, SearchPanel} from "../../../Document/components";
import FileListTabMode from "../../../Document/components/FileListWindow/FileListTabMode";

const ESignListWindow = (props) => {
  const {
    title = 'eSign Documents',
    subtitle = 'Available eSign Documents',
    initialStatus = ESIGNING_STATUS.COMPLETED,
    includeStatusFilter = false,
    initialBeginDate = "01/01/2000",
    includeBeginDate = false,
    initialEndDate = moment().format("MM/DD/yyyy"),
    includeEndDate = false,
    viewer = DOCUMENT_VIEWER_MODES.ESIGNING,
    getESignDocumentFromESignServiceMethod,
    searchESignDocumentFromESignDocumentServiceMethod
  } = props;

  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    id,
    companyId,
    company,
    role
  } = useSelector(state => state.authentication.user);

  const [statusSelect, setStatusSelect] = useState(initialStatus);
  const [beginDate, setBeginDate] = useState(initialBeginDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const filteredDocs = useSelector(state => {
      return state.eSignDocuments.items
    }
  );
  const requestPending = useSelector(state => {
      return state.eSignDocuments.requestPending;
    }
  );

  const [statusList] = useState([
    ESIGNING_STATUS.COMPLETED,
    ESIGNING_STATUS.PENDING,
    ESIGNING_STATUS.UNSENT,
    ESIGNING_STATUS.WAITING_FOR_OTHERS
  ]);

  const [initialLoad, setInitialLoad] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [searchFields] = useState({
    status: statusSelect,
    start_date: beginDate,
    end_date: endDate,
  });

  const handleBeginDateChange = date => {
    searchDocWithFilters(statusSelect, date, endDate);
    setBeginDate(date);
  };

  const handleClickedView = rowData => {
    let index = files.findIndex(x => x.id === rowData.guid);
    if (index === -1) {
      let document = getESignDocument(rowData.document_name, rowData.id).then(document => {
        setFiles(prevState => [...prevState, {id: rowData.id, data: document}]);
        return document;
      });
      loadTab(rowData, document, rowData.status)
    } else {
      loadTab(rowData, files[index], rowData.status)
    }
  }

  const handleEndDateChange = date => {
    searchDocWithFilters(statusSelect,beginDate, date);
    setEndDate(date);
  };

  const handleFilterClick = event => {
    searchDocWithFilters();
  };

  const handleStatusSelect = event => {
    searchDocWithFilters(event.target.value);
    setStatusSelect(event.target.value);
  };

  async function getESignDocument(documentName, documentId) {
    const documentFields = {
      'document_name': documentName,
      'id': documentId,
      'userId': id,
      'accessToken': ''
    }
    return await getESignDocumentFromESignServiceMethod(documentFields)
      .then(document => {
          return document;
      });
  }

  function loadNewTab(tabData, document, status) {
    tabListRef.current.addTab(
      (tabId)=>(tabData.document_name) ? (tabData.document_name) : ('PANEL ' + tabId),
      (tabId) => FileListTabMode.ESIGN,
      (tabId)=>(<ESignViewer
        classes={classes}
        file={document}
        tabData={tabData}
        guid={tabData.guid}
        document_id={tabData.id}
        displayName={tabData.document_name}
        status={status}
        tabId={tabId}
        view={viewer}
      />)
    );
  }

  function loadTab(tabData, documentData, status) {
    let labelFound = tabListRef.current.tabList.filter(tabValue => {
      if (tabData.display_name === tabValue.label) {
        tabListRef.current.changeTab(tabValue.id);
        return 1;
      } else {
        return 0;
      }
    });
    if (labelFound.length === 0) {
      loadNewTab(tabData, documentData, status);
    }
  }


  function searchDocWithFilters(newStatus=statusSelect, newBeginDate=beginDate, newEndDate=endDate) {
    setLoading(true);
    const currentSearchFields = {
      ...searchFields,
      status: newStatus.toLowerCase(),
      start_date: newBeginDate,
      end_date: newEndDate,
    }

    const searchESignDocument = async (currentSearchFields)  => {
      await dispatch(searchESignDocumentFromESignDocumentServiceMethod(currentSearchFields));
    }

    searchESignDocument(currentSearchFields)
      .then(dtls => {
            setLoading(false);
          });
  }

  const searchDocWithFiltersCallback = useCallback(searchDocWithFilters,
    [dispatch, searchFields, statusSelect, beginDate, endDate, searchESignDocumentFromESignDocumentServiceMethod]);

  const filterCard = (!filteredDocs || initialLoad) ?
    (<LoadingSpinner/>) :
    (<Card
      plain
      style={{margin: 0}}
    >
      <CardBody style={{padding: 0}}>
        <Grid
          alignItems={'center'}
          container
          justifyContent={'center'}
          style={{padding: 0, margin: 0}}
        >
          <AccordionCard
              classes={classes}
              summaryText="ESign Document Filters"
              company={company}
              role={role}
              expanded={expanded}
              setExpanded={setExpanded}

              initialStatus={statusList}
              statusSelect={statusSelect}
              beginDate={beginDate}
              endDate={endDate}

              renderFileName={false}
              renderAttributes={false}
              renderCompany={false}
              renderSection={false}
              renderClassification={false}
              renderCategory={false}

              onHandleStatusSelect={includeStatusFilter ? handleStatusSelect : undefined}
              onHandleBeginDateSelect={includeBeginDate ? handleBeginDateChange : undefined}
              onHandleEndDateSelect={includeEndDate ? handleEndDateChange : undefined}
              renderButton={false}
              buttonText="Filter"
              buttonIcon={FilterListIcon}
              onButtonClick={handleFilterClick}
          />
          {requestPending ? (<LoadingSpinner/>) : (
            <ESignDocumentDetails
              classes={classes}
              company={company}
              role={role}

              initialSections={filteredDocs.sections}
              initialCompanies={filteredDocs.companies}
              initialCategories={filteredDocs.categories}
              initialClassifications={filteredDocs.classifications}
              initialDocuments={filteredDocs.documents}

              status={statusSelect}
              onView={handleClickedView}
              viewer={viewer}
            />
          )}
        </Grid>
      </CardBody>
    </Card>);

  const tabListRef = React.useRef({})

  const tabList = (<TabList
    label="eSign Documents Tabs"
    indicatorColor="secondary"
    scrollButtons="auto"
    textColor="primary"
    variant="scrollable"
    defaultTabName="eSign Documents"
    defaultTabPanel={filterCard}
    ref={tabListRef}
  />)

  useEffect(() => {
    if (initialLoad) {
      searchDocWithFiltersCallback();
      setInitialLoad(false);
    }
  }, [dispatch, filteredDocs, initialLoad, searchDocWithFiltersCallback]);

  return (
    <div className={classes.root}>
      <PageHeader title={title} subTitle={subtitle}/>
      <Card className={classes.content}>
        <CardBody style={{backgroundColor: '#FFF', padding: 0}}>
          <Paper
            elevation={1}
            style={{padding: 10, margin: 0}}
          >
            {tabList}
          </Paper>
        </CardBody>
      </Card>
    </div>
  )
}

export default ESignListWindow;
